import GlassFrogModel from 'legacy/GlassFrog/GlassFrogModel'

const Integration = GlassFrogModel.extend({}, {
  resourceName: 'integrations',
})

export default Integration
